import { Injectable, inject } from '@angular/core';
import { TranslationService } from '@waseel-asp/tpa-waseel-lib-staging';
import { getButtonConfig } from '../../functions/config-function';
import { generateGUID } from '../../functions/guid-function';

@Injectable({
  providedIn: 'root'
})
export class ButtonHelperService {
  private translation = inject(TranslationService);

  getEditButtonConfig(isTextVisible?: boolean) {
    const button = {
      id: 'edit' + generateGUID(),
      buttonText: isTextVisible ? this.translation.instant('COMMON.EDIT') : '',
      color: '',
      isRounded: false,
      isPrimary: false,
      buttons: [],
      imgUrl: './assets/images/ic-edit.svg',
      tooltipText: this.translation.instant('COMMON.EDIT'),
      visibleCallback: null
    };
    return button;
  }

  getDeleteButtonConfig(isTextVisible?: boolean) {
    const button = {
      id: 'delete' + generateGUID(),
      buttonText: isTextVisible ? this.translation.instant('FORM_FIELD.DELETE') : '',
      isRounded: false,
      isPrimary: false,
      buttons: [],
      imgUrl: './assets/images/ic-delete.svg',
      tooltipText: this.translation.instant('FORM_FIELD.DELETE'),
      visibleCallback: null
    };
    return button;
  }

  getAssignedButtonConfig(isReAssign: boolean, isTextVisible?: boolean) {
    const button = {
      id: 'assignedTo' + generateGUID(),
      buttonText: isTextVisible ? this.translation.instant(`PREAUTH.PREAUTH_TRANSACTION.${isReAssign ? 'RE_ASSIGNED_TO' : 'ASSIGNED_TO'}`) : '',
      isRounded: false,
      isPrimary: false,
      buttons: [],
      imgUrl: './assets/images/assignment.svg',
      tooltipText: this.translation.instant(`PREAUTH.PREAUTH_TRANSACTION.${isReAssign ? 'RE_ASSIGNED_TO' : 'ASSIGNED_TO'}`)
    };
    return button;
  }

  getAdjudicationButtonConfig(isTextVisible?: boolean) {
    const button = {
      id: 'approvalProcess' + generateGUID(),
      buttonText: isTextVisible ? this.translation.instant('PREAUTH.PREAUTH_TRANSACTION.ADJUDICATION') : '',
      isRounded: false,
      isPrimary: false,
      buttons: [],
      imgUrl: './assets/images/adjudication.svg',
      tooltipText: this.translation.instant('PREAUTH.PREAUTH_TRANSACTION.ADJUDICATION'),
    };
    return button;
  }

  getCancelButtonConfig(isTextVisible?: boolean) {
    const button = {
      id: 'cancel' + generateGUID(),
      buttonText: isTextVisible ? this.translation.instant('COMMON.CANCEL') : '',
      isRounded: false,
      isPrimary: false,
      buttons: [],
      imgUrl: './assets/images/cancel.svg',
      tooltipText: this.translation.instant('COMMON.CANCEL')
    };
    return button;
  }

  getNotRequiredButtonConfig(isTextVisible?: boolean) {
    const button = {
      id: 'notRequired' + generateGUID(),
      buttonText: isTextVisible ? this.translation.instant('PREAUTH.STATUS_TYPE.NOT_REQUIRED') : '',
      isRounded: false,
      isPrimary: false,
      buttons: [],
      imgUrl: './assets/images/ic-not-required.svg',
      tooltipText: this.translation.instant('PREAUTH.STATUS_TYPE.NOT_REQUIRED')
    };
    return button;
  }

  getCreatePBMButtonConfig(isTextVisible?: boolean) {
    const button = {
      id: 'createPBM' + generateGUID(),
      buttonText: isTextVisible ? this.translation.instant('COMMON.CREATE_PBM') : '',
      isRounded: false,
      isPrimary: false,
      buttons: [],
      imgUrl: './assets/images/ic-add-black.svg',
      tooltipText: this.translation.instant('COMMON.CREATE_PBM')
    };
    return button;
  }

  getUpdatePBMButtonConfig(isTextVisible?: boolean) {
    const button = {
      id: 'updatepbm' + generateGUID(),
      buttonText: isTextVisible ? this.translation.instant('COMMON.UPDATE_PBM') : '',
      color: '',
      isRounded: false,
      isPrimary: false,
      buttons: [],
      imgUrl: './assets/images/ic-edit.svg',
      tooltipText: this.translation.instant('COMMON.UPDATE_PBM'),
      visibleCallback: null
    };
    return button;
  }

  getDisagreeButtonConfig(isTextVisible?: boolean) {
    const button = {
      id: 'cancel' + generateGUID(),
      buttonText: isTextVisible ? this.translation.instant('COMMON.DISAGREE') : '',
      isRounded: false,
      isPrimary: false,
      buttons: [],
      imgUrl: './assets/images/cancel-primary.svg',
      tooltipText: this.translation.instant('COMMON.DISAGREE')
    };
    return button;
  }

  getAcceptButtonConfig(isTextVisible?: boolean) {
    const button = {
      id: 'accept' + generateGUID(),
      buttonText: isTextVisible ? this.translation.instant('COMMON.AGREE') : '',
      isRounded: false,
      isPrimary: false,
      buttons: [],
      imgUrl: './assets/images/check-primary.svg',
      tooltipText: this.translation.instant('COMMON.AGREE')
    };
    return button;
  }

  getMarkReadButton(isTextVisible?: boolean) {
    const button = {
      id: 'markasread' + generateGUID(),
      buttonText: isTextVisible ? this.translation.instant('NOTIFICATION.MARK_AS_READ') : '',
      isRounded: false,
      isPrimary: false,
      buttons: [],
      imgUrl: './assets/images/check-primary.svg',
      tooltipText: this.translation.instant('NOTIFICATION.MARK_AS_READ')
    };
    return button;
  }

  getActivateButtonConfig(isTextVisible?: boolean) {
    const button = {
      id: 'activate' + generateGUID(),
      buttonText: isTextVisible ? this.translation.instant('COMMON.ACTIVATE_CLAIM') : '',
      isRounded: false,
      isPrimary: false,
      buttons: [],
      imgUrl: './assets/images/ic-link-active.svg',
      tooltipText: this.translation.instant('COMMON.ACTIVATE_CLAIM')
    };
    return button;
  }

  getViewButtonConfig(isTextVisible?: boolean) {
    const button = {
      id: 'view' + generateGUID(),
      buttonText: isTextVisible ? this.translation.instant('COMMON.VIEW') : '',
      isRounded: false,
      isPrimary: false,
      buttons: [],
      imgUrl: './assets/images/ic-eye-open.svg',
      tooltipText: this.translation.instant('COMMON.VIEW')
    };
    return button;
  }

  getDeActivateButtonConfig(isTextVisible?: boolean) {
    const button = {
      id: 'DeActivate' + generateGUID(),
      buttonText: isTextVisible ? this.translation.instant('COMMON.DEACTIVE_CLAIM') : '',
      isRounded: false,
      isPrimary: false,
      buttons: [],
      imgUrl: './assets/images/ic-link-inactive.svg',
      tooltipText: this.translation.instant('COMMON.DEACTIVE_CLAIM')
    };
    return button;
  }

  getPrintButtonConfig(isTextVisible?: boolean) {
    const button = {
      id: 'print' + generateGUID(),
      buttonText: isTextVisible ? this.translation.instant('COMMON.PRINT') : '',
      isRounded: false,
      isPrimary: false,
      buttons: [],
      imgUrl: './assets/images/print.svg',
      tooltipText: this.translation.instant('COMMON.PRINT'),
    };
    return button;
  }

  getDownloadButtonConfig(isTextVisible?: boolean) {
    const button = {
      id: 'download' + generateGUID(),
      buttonText: isTextVisible ? this.translation.instant('COMMON.DOWNLOAD') : '',
      isRounded: false,
      isPrimary: false,
      buttons: [],
      imgUrl: './assets/images/ic-download.svg',
      tooltipText: this.translation.instant('COMMON.DOWNLOAD'),
    };
    return button;
  }

  getTransactionButtonConfig(isTextVisible?: boolean) {
    const button = {
      id: 'download' + generateGUID(),
      buttonText: isTextVisible ? this.translation.instant('COMMON.TRANSACTION') : '',
      isRounded: false,
      isPrimary: false,
      buttons: [],
      imgUrl: './assets/images/document-white.svg',
      tooltipText: this.translation.instant('COMMON.TRANSACTION'),
    };
    return button;
  }

  getResetPasswordButtonConfig(isTextVisible?: boolean) {
    const button = {
      id: 'reset' + generateGUID(),
      buttonText: isTextVisible ? this.translation.instant('FORM_FIELD.RESET_PASSWORD') : '',
      color: '',
      isRounded: false,
      isPrimary: false,
      buttons: [],
      imgUrl: './assets/images/reset-password.svg',
      tooltipText: this.translation.instant('FORM_FIELD.RESET_PASSWORD'),
    };
    return button;
  }

  getFollowUpButtonConfig(isTextVisible?: boolean) {
    const button = {
      id: 'followUp' + generateGUID(),
      buttonText: isTextVisible ? this.translation.instant('COMMON.FOLLOW_UP') : '',
      color: '',
      isRounded: false,
      isPrimary: false,
      buttons: [],
      imgUrl: './assets/images/ic-reply-black.svg',
      tooltipText: this.translation.instant('COMMON.FOLLOW_UP')
    };
    return button;
  }

  getRelatedApprovalButtonConfig(isTextVisible?: boolean) {
    const button = {
      id: 'relatedApproval' + generateGUID(),
      buttonText: isTextVisible ? this.translation.instant('COMMON.FOLLOW_RELATED') : '',
      color: '',
      isRounded: false,
      isPrimary: false,
      buttons: [],
      imgUrl: './assets/images/ic-link-active.svg',
      tooltipText: this.translation.instant('COMMON.FOLLOW_RELATED')
    };
    return button;
  }

  getReletedClaimButtonConfig(isTextVisible?: boolean) {
    const button = {
      id: 'relatedClaim' + generateGUID(),
      buttonText: isTextVisible ? this.translation.instant('CLAIM.VIEW_CLAIMS.CREATE_RELETED_CLAIM') : '',
      color: '',
      isRounded: false,
      isPrimary: false,
      buttons: [],
      imgUrl: './assets/images/ic-link-active.svg',
      tooltipText: this.translation.instant('CLAIM.VIEW_CLAIMS.CREATE_RELETED_CLAIM')
    };
    return button;
  }

  getSubmitButtonConfig(isTextVisible?: boolean) {
    const button = {
      id: 'submit' + generateGUID(),
      buttonText: isTextVisible ? this.translation.instant('COMMON.SUBMIT') : '',
      color: '',
      isRounded: false,
      isPrimary: false,
      buttons: [],
      imgUrl: './assets/images/ic-submit.svg',
      tooltipText: this.translation.instant('COMMON.SUBMIT')
    };
    return button;
  }

  getSendButtonConfig(isTextVisible?: boolean) {
    const button = {
      id: 'send' + generateGUID(),
      buttonText: isTextVisible ? this.translation.instant('NPHIES.MODULE_TYPE.PAYMENT_NOTICE') : '',
      color: '',
      isRounded: false,
      isPrimary: false,
      buttons: [],
      imgUrl: './assets/images/send_button.svg',
      tooltipText: this.translation.instant('NPHIES.MODULE_TYPE.PAYMENT_NOTICE')
    };
    return button;
  }

  getERPSingleRecordSyncButtonConfig(isTextVisible?: boolean) {
    return getButtonConfig(null, 'erp-sync-btn', 'icon', 'basic', isTextVisible ? this.translation.instant('COMMON.SINGLE_DATA_SYNC_WITH_ERP') : '', true, null,
      'sync', null, this.translation.instant('COMMON.SINGLE_DATA_SYNC_WITH_ERP'), null, ['grid-action-btn-primary']);
  }

}